import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import { GlobalStyles } from '@mui/material';
import { TenantBootstrap } from './tenancy/TenantBootstrap';
import { BrowserRouter } from 'react-router-dom';
import { RuntimeMaintenanceGate } from './runtime/RuntimeMaintenanceGate';

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles styles={{
        '@font-face': {
          fontFamily: 'Shrikhand',
          fontStyle: 'normal',
          fontDisplay: 'swap',
          fontWeight: 400,
          src: "url('/fonts/Shrikhand-Regular.ttf') format('truetype')",
        },
        '.grecaptcha-badge': {
          visibility: 'hidden !important',
          opacity: '0 !important',
          pointerEvents: 'none !important',
        },
      }} />
      <CssBaseline /> {/* Ensures consistent baseline styling */}
      <BrowserRouter>
        <RuntimeMaintenanceGate>
          <TenantBootstrap>
            <App />
          </TenantBootstrap>
        </RuntimeMaintenanceGate>
      </BrowserRouter>
    </ThemeProvider>  </React.StrictMode>
);
